import { render, staticRenderFns } from "./nav-footer.vue?vue&type=template&id=cb698c72&scoped=true"
import script from "./nav-footer.vue?vue&type=script&lang=js"
export * from "./nav-footer.vue?vue&type=script&lang=js"
import style0 from "./nav-footer.vue?vue&type=style&index=0&id=cb698c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb698c72",
  null
  
)

export default component.exports